import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { mergeRegister } from "@lexical/utils";
import { $getSelection, $isRangeSelection } from "lexical";
import { useEffect } from "react";
import { $createDividerNode } from "../nodes/divider-mui";
import type { InsertDividerCommand } from "../types/commands";
import { INSERT_DIVIDER_COMMAND } from "../types/commands";
import { $insertNode } from "../utils/insert-node";

export function DividerPlugin(): null {
  const [editor] = useLexicalComposerContext();

  useEffect(
    () =>
      mergeRegister(
        editor.registerCommand(
          INSERT_DIVIDER_COMMAND,
          (data: InsertDividerCommand) => {
            const selection = $getSelection();

            const node = $createDividerNode(editor._headless, data);

            $isRangeSelection(selection) ? $insertNode(node) : selection?.insertNodes([node]);

            return true;
          },
          1,
        ),
      ),
    [editor],
  );

  return null;
}
